import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { InvalidStateError } from '@stacks/common';
var SESSION_VERSION = '1.0.0';
export var SessionData =
/*#__PURE__*/
function () {
  function SessionData(options) {
    _classCallCheck(this, SessionData);

    this.version = SESSION_VERSION;
    this.userData = options.userData;
    this.transitKey = options.transitKey;
    this.etags = options.etags ? options.etags : {};
  }

  _createClass(SessionData, [{
    key: "toString",
    value: function toString() {
      return JSON.stringify(this);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(json) {
      if (json.version !== SESSION_VERSION) {
        throw new InvalidStateError("JSON data version ".concat(json.version, " not supported by SessionData"));
      }

      var options = {
        coreNode: json.coreNode,
        userData: json.userData,
        transitKey: json.transitKey,
        etags: json.etags
      };
      return new SessionData(options);
    }
  }]);

  return SessionData;
}();